/**
 * Vuex "restrict" module (registered as `restrict` in the root store).
 *
 * Aggregates reply/user-restriction state: state (store.js), actions
 * (operations.js), getters (selectors.js), and mutations (updates.js).
 */
import actions from './operations';
import getters from './selectors';
import mutations from './updates';
import state from './store';

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
